var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "board-list-faq"
  }, [_c('v-expansion-panels', {
    attrs: {
      "accordion": ""
    }
  }, _vm._l(_vm.faqs, function (faq, index) {
    var _faq$answer, _faq$answer$replace;

    return _c('v-expansion-panel', {
      key: index
    }, [_c('v-expansion-panel-header', [_c('div', {
      staticClass: "d-flex align-center"
    }, [_c('v-avatar', {
      staticClass: "mr-10px",
      attrs: {
        "color": "primary",
        "size": "32"
      }
    }, [_c('strong', {
      staticClass: "font-size-14 white--text mt-n2px"
    }, [_vm._v("Q")])]), _c('strong', {
      staticClass: "font-weight-medium line-height-12"
    }, [_vm._v(_vm._s(faq.question))])], 1)]), _c('v-expansion-panel-content', [_c('v-row', {
      attrs: {
        "no-gutters": ""
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "12",
        "md": "auto"
      }
    }, [_c('v-avatar', {
      staticClass: "mb-6px mr-10px mb-md-0px",
      attrs: {
        "color": "secondary",
        "size": "32"
      }
    }, [_c('strong', {
      staticClass: "font-size-14 white--text mt-n2px"
    }, [_vm._v("A")])])], 1), _c('v-col', {
      attrs: {
        "cols": "12",
        "md": "auto"
      }
    }, [_c('p', {
      staticClass: "line-height-16",
      domProps: {
        "innerHTML": _vm._s((_faq$answer = faq.answer) === null || _faq$answer === void 0 ? void 0 : (_faq$answer$replace = _faq$answer.replace) === null || _faq$answer$replace === void 0 ? void 0 : _faq$answer$replace.call(_faq$answer, /\n/g, '<br>'))
      }
    })])], 1)], 1)], 1);
  }), 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }